/* @flow */
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import TeacherInfoCollection from 'user/components/TeacherInfoCollection.jsx';
import PromptStore from 'stores/PromptStore';
import { PromptNames } from 'constants/PromptConstants';
import { mountModal } from 'lib/modal';

class ProfileCompletenessModals extends React.Component {
  componentDidMount() {
    this.checkForPrompts();
  }

  componentDidUpdate() {
    this.checkForPrompts();
  }

  checkForPrompts() {
    let modalBody;
    if (PromptStore.getAvailable(PromptNames.TEACHER_INFO_COLLECTION)) {
      modalBody = <TeacherInfoCollection />;
    }

    if (modalBody) {
      const modal = <Dialog size="xlarge">{modalBody}</Dialog>;
      mountModal(modal, this);
    }
  }

  render() {
    return null;
  }
}

export default ProfileCompletenessModals;



// WEBPACK FOOTER //
// ./src/user/components/ProfileCompletenessModals.jsx